import { observer } from 'mobx-react-lite';
import { Route } from 'react-router-dom';
import HomePage from '../../features/home/HomePage';
import { ToastContainer } from 'react-toastify';
import ModalContainer from '../common/modals/ModalContainer';
import AgreementConfirmation from '../../features/residents/AgreementConfirmation';
import InvalidResident from '../../features/errors/InvalidResident';
import ServerError from '../../features/errors/ServerError';
import NotFound from '../../features/errors/NotFound';

function App() {
  // const location = useLocation();
  // const query = new URLSearchParams(location.search);
  
  return (
    <>
      <ToastContainer position='bottom-right' hideProgressBar />
      <ModalContainer />
      <Route exact path='/' component={InvalidResident} />
      <Route path='/verify/:sid' component={HomePage} />    
      <Route path='/confirm' component={AgreementConfirmation} />      
      <Route path='/invalid' component={InvalidResident} />
      <Route path='/server-error' component={ServerError} />
      <Route path='/not-found' component={NotFound} />
    </>
  );
}

export default observer(App);
